import { p2ePortalUrl } from "../config";

export const openP2EPortal = () => window.open(p2ePortalUrl, "_blank");
